import { ReduxActionType } from 'types';
export interface UserDetails {
  id: number;
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  phoneNumber: string;
}

interface ActionTypes {
  FETCH_IUSER_START: ReduxActionType;
  FETCH_IUSER_SUCCESS: ReduxActionType;
  FETCH_IUSER_FAILURE: ReduxActionType;
}

export const IUserActionTypes: ActionTypes = {
  FETCH_IUSER_START: '@@FETCH_IUSER_START',
  FETCH_IUSER_SUCCESS: '@@FETCH_IUSER_SUCCESS',
  FETCH_IUSER_FAILURE: '@@FETCH_IUSER_FAILURE'
};

export interface ImpersonateUserParams {
  userId: number;
  organisationId?: number;
}
export interface ImpersonateUserState {
  loading: boolean;
  token: string;
  user: UserDetails | Object;
  expiry: string;
}
